import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgDistributedCacheServiceForRedis = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-distributed-cache-service-for-redis';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M7.5 4.232 3.02 6.821l-.01 5.169L3 17.159l.15.094c.082.051 2.107 1.224 4.5 2.604L12 22.368l4.35-2.511c2.392-1.38 4.418-2.553 4.5-2.604l.15-.094-.01-5.169-.01-5.169-4.48-2.589A679 679 0 0 0 12 1.643c-.011 0-2.036 1.165-4.5 2.589m8.223 1.286 3.737 2.157.01 2.653.011 2.653-3.707 2.14C13.736 16.297 12.038 17.26 12 17.26s-1.736-.963-3.774-2.139l-3.707-2.14.011-2.653.01-2.652 3.72-2.154 3.723-2.158c.002-.002 1.685.967 3.74 2.154M8.33 16.912l3.67 2.12 3.73-2.154 3.73-2.153.011.784c.006.432-.003.799-.02.815s-1.701.993-3.741 2.171L12 20.636l-3.73-2.153-3.73-2.154-.011-.806c-.01-.761-.007-.805.06-.768.039.021 1.722.992 3.741 2.157"
    })
  }));
});
export default SvgDistributedCacheServiceForRedis;